import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


export const booksApi = createApi({
    reducerPath: 'books',
    baseQuery: fetchBaseQuery({ baseUrl: 'http://localhost:9000' }),
    tagTypes:['books','book'],
    endpoints: (builder) => ({
      getBooks: builder.query({
        query: () => `books`,
        providesTags:['books']
      }),
      getBook: builder.query({
        query: (id) => `books/${id}`,

        providesTags:['book']

      }),
      postBook: builder.mutation({

        query: (data) => ({
          url: `books`,
          method: 'POST',
          body: data,
        }),
  

        invalidatesTags:['books'],
      }),
     deleteBook: builder.mutation({

        query: (bookId) => ({
          url: `books/${bookId}`,
          method: 'DELETE',
          
        }),

        invalidatesTags:['books'],
      }),
      updatePost: builder.mutation({
      
        query: ({ id, ...restData }) => ({
          url: `books/${id}`,
          method: 'PATCH',
          body: restData,
        }),
        invalidatesTags:['books','book'],

      })
    }),
  })


  export const { useGetBooksQuery, useGetBookQuery,usePostBookMutation,useUpdatePostMutation,useDeleteBookMutation } = booksApi;